import React from "react";
import { WithCartProps } from "./WithCartProps";
import { useCart } from "./CartContext";

export const withCart = <P extends object>(Component: React.ComponentType<P & WithCartProps>) => {
    return (props: P) => {
        const { cart } = useCart();

        return <Component {...props} cart={cart} />;
    };
};